module.exports = __webpack_public_path__ + "img/secure.dcf57969.png";